import Gauge from '@/components/Gauge';

import { Text } from '@simplywallst/ui-core';

import { formatterPercentage } from '@/utilities/format';

import { Card } from '../Card';

export interface Props {
  portfolioValue: number | null;
  marketValue: number | null;
}

export const ReturnOnCapitalEmployed = ({
  portfolioValue,
  marketValue,
}: Props) => {
  return (
    <Card
      title="Return on Capital Employed"
      description={
        <Text color="inherit" typography="xSmall">
          This chart illustrates the comparison of the Portfolio's Return on
          Capital Employed (ROCE) with the broader market's average. ROCE is a
          vital financial metric that evaluates a company's profitability and
          efficiency in using its capital. It measures the returns that a
          company achieves from its capital employed, providing insight into how
          effectively the invested capital is being utilized to generate
          profits. In this chart, the direct comparison of your portfolio's ROCE
          with the market average offers a clear perspective on your portfolio's
          effectiveness in using its capital relative to the broader market. A
          higher ROCE indicates more efficient use of capital in generating
          profits, while a lower ROCE may point to less efficiency. Utilize this
          comparison to assess the relative efficiency and financial performance
          of your portfolio compared to the market, guiding your strategic
          investment decisions.{' '}
          <a
            href="https://support.simplywall.st/hc/en-us/articles/9423775242383-Understanding-the-New-Portfolio-Analysis-Calculations"
            rel="noreferrer nofollow"
            target="_blank"
          >
            Learn more
          </a>
        </Text>
      }
    >
      <Gauge
        keys={['portfolio', 'market']}
        entities={{
          portfolio: portfolioValue,
          market: marketValue,
        }}
        numTicks={5}
        title="ROCE Ratio"
        from={0}
        to={0.3}
        formatter={formatterPercentage}
      />
    </Card>
  );
};
